// Edit layer style > Rule > Geometry > Color Scheme > Single Color

import { Stack, Typography } from '@mui/material';
import { theme_textColorBlended } from '../../../Theme';
import { MuiColorInputStyled } from '../EditLayerStyle';
import { MuiColorInputColors } from 'mui-color-input';
import { ILayerStyleRule_Geometry, ILayerStyleType_SingleColor } from './LayerStyleInterfaces';


export const SINGLE_COLOR_DEFAULT = "#A06060";



//-------------------------------------------------------------------------------
// Component props
//-------------------------------------------------------------------------------
export interface EditLayerStyle_ColorScheme_SingleColor_Props
{
  ruleGeom?: ILayerStyleRule_Geometry;   // input (if undefined, there is no geom section in the rule)
  OnRuleSingleValueUpdated: any;      // output
}

//-------------------------------------------------------------------------------
// Edit layer style > Rule > Geometry > Color Scheme > Single Color
//-------------------------------------------------------------------------------
export function EditLayerStyle_ColorScheme_SingleColor(props: EditLayerStyle_ColorScheme_SingleColor_Props) 
{









  //-------------------------------------------------------------------------------
  // The color has changed.
  //-------------------------------------------------------------------------------
  function OnColorChanged(value: string, colors: MuiColorInputColors)
  {
    if(!props.ruleGeom || !props.ruleGeom.single_color) return;

    let updatedItem: ILayerStyleType_SingleColor =
    {
      ...props.ruleGeom.single_color,
      color: value
    }

    // Notify caller of the change
    props.OnRuleSingleValueUpdated(updatedItem);
  }











  

  if(!props.ruleGeom || !props.ruleGeom.single_color) return null;


  // Main render

  return (

    <Stack sx={{ mx: 0, mt: 2 }}>

      <MuiColorInputStyled name='single_color' variant='standard' size='small' format='hex' isAlphaHidden={true}
                           value={props.ruleGeom.single_color.color} 
                           onChange={(v,c)=>OnColorChanged(v,c)}
                           label=
                           {
                             <Typography sx={{color: theme_textColorBlended+'B0'}}>
                               Color
                             </Typography>
                           }
                           sx={{ ml: 0, width: '110px' }}/>
    </Stack>
  )
}





//-------------------------------------------------------------------------------
// Get default color scheme: SINGLE COLOR
//-------------------------------------------------------------------------------
export function GetDefaultLayerStyle_SingleColor(): ILayerStyleType_SingleColor
{
  const defaultItem: ILayerStyleType_SingleColor =
  {
    color: SINGLE_COLOR_DEFAULT
  }

  return defaultItem;
}

//-------------------------------------------------------------------------------
// Validates the specified rule geometry SINGLE COLOR color scheme.
//
// Works for both regular rules and the special global defaults rule.
// 
// Returns an error message if validation FAILS, or empty string if it succeeds.
//-------------------------------------------------------------------------------
export function ValidateLayerStyleRuleGeom_SingleColor(single_color: ILayerStyleType_SingleColor | undefined, 
                                                       errMsgPrefix: string): string
{
  if(single_color === undefined)
    return errMsgPrefix + 'Invalid color scheme';

  // This color scheme has nothing that needs to be validated

  // Success
  return '';
}